import { Button, Logo } from 'components'
import { buttons, navLinks } from 'assets/config/header'

import { NavLink } from 'react-router-dom'
import React from 'react'
import styles from './MobileMenu.module.scss'

const MobileMenu = ({
  onClick
}) => {

  return (
    <div className={styles.background}>
      <div className={styles.wrapper}>
        <NavLink to='/'>
          <Logo />
        </NavLink>
        { 
          navLinks.map(navLink => (
            <NavLink 
              to={navLink.to} 
              className={styles.navLink}
              activeClassName={styles.navLink_active}
              onClick={onClick}
            >
              {navLink.name}
            </NavLink>
          ))
        }
        { 
          buttons.map(button => (
            <NavLink 
              to={button.to} 
              className={styles.navLink}
              activeClassName={styles.navLink_active}
              onClick={onClick}
            >
              {button.name}
            </NavLink>
          ))
        }
      </div>
    </div>
  )
}

export { MobileMenu as default }